import React from 'react';

import MTabsPaneView from './MTabsPane.view';

type Props<Tabs extends string> = {
  text: string | JSX.Element;
  id: Tabs;
  className?: string;
};

const MTabsPane = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return (
    <MTabsPaneView className={props.className} id={props.id} text={props.text}>
      {props.children}
    </MTabsPaneView>
  );
};

MTabsPane.displayName = 'MTabsPane';

export default MTabsPane;
